export default "__VITE_ASSET__B6MXb8OL__"